var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, } from "vue-property-decorator";
import { namespace, } from "vuex-class";
import CommonTitle from "~/components/common/common-title.vue";
import SvgIcon from "~/components/common/svg-icon.vue";
import AddWarning from "~/components/case-adjustment/add-warning.vue";
import { Dependencies } from "~/core/decorator";
import { SmsTemplateService } from "~/services/business-service/sms-template-service";
import assetsRequest from "~/utils/assets.request";
import fsRequest from "~/utils/fs.request";
import { PersonalService } from "~/services/business-service/personal.service";
var collectionManageModule = namespace("collection-manage");
var AccountInfo = /** @class */ (function (_super) {
    __extends(AccountInfo, _super);
    function AccountInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * 卡号
         */
        _this.phones = [];
        _this.card = [];
        _this.smsTemplateList = [];
        _this.formModel = {};
        _this.currentRow = {};
        _this.rules = {
            caseType: [{ required: true, message: "请选择调解方式", trigger: "blur" }],
        };
        _this.dialogShow = false;
        _this.smsDialogShow = false;
        _this.activeFlagAccount = ""; //动态绑定class标识
        _this.activeFlagNum = ""; //动态绑定class标识
        _this.tjCaseNumber = "";
        _this.pNameMapAsMap = new Map([
            ["新网银行行调", "新网银行"],
            ["新网银行", "新网银行"],
            ["金昆租机", "金昆租机"],
            ["探物网络科技", "探物网络科技"],
            ["八戒租赁", "八戒租赁"],
            ["厦门银行", "厦门银行"],
            ["厦门银行行调", "厦门银行"],
            ["厦门银行北京分行", "厦门银行"],
            ["将舒租机", "将舒租机"],
            ["兴业银行", "兴业银行"],
            ["昆朋", "昆朋"],
            ["民生银行", "民生银行"],
            ["美团", "美团"],
            ["青年优品", "青年优品"],
            ["厦门国际", "厦门国际"],
            ["招联", "招联"],
            ["唯品富邦", "唯品富邦"],
        ]);
        return _this;
    }
    Object.defineProperty(AccountInfo.prototype, "accNumber", {
        get: function () {
            return this.accountNumber;
        },
        enumerable: false,
        configurable: true
    });
    AccountInfo.prototype.mounted = function () {
        var _this = this;
        this.smsTemplateService.findAllSmsTemplate({}).subscribe(function (data) {
            _this.smsTemplateList = data;
        });
        this.setCard(this.accountNumber);
        this.onChangeAccount(this.card[0]);
    };
    AccountInfo.prototype.onCurrentCaseChange = function () {
        var _this = this;
        if (this.currentCase && this.currentCase.certificateNo) {
            assetsRequest.get("/tjCaseQuery/getCaseNo", {
                idNumber: this.currentCase.certificateNo,
            }).then(function (data) {
                var _a;
                _this.tjCaseNumber = (_a = data.data[0]) === null || _a === void 0 ? void 0 : _a.caseNo;
            });
            this.getPhone();
        }
    };
    AccountInfo.prototype.accountNumberChange = function (val) {
        var _this = this;
        if (!val.length)
            return;
        var params = val.filter(function (x) { return x.account === _this.currentCase.account; });
        this.updateCardModel(params[0]);
        this.setCard(this.currentCase.account);
        this.activeFlagAccount = this.currentCase.account;
        this.activeFlagNum = this.card[0].cardNo;
    };
    AccountInfo.prototype.handleCurrentChange = function (val) {
        this.currentRow = val;
    };
    AccountInfo.prototype.setCard = function (accountNumber) {
        var _this = this;
        if (!accountNumber)
            return;
        this.card = [];
        var cardSet = this.cardInfo.filter(function (e) { return e.account === accountNumber; });
        cardSet.map(function (e) {
            var cardModel = {
                cardNo: e.cardNo,
                no: e.account,
                amt: e.leftAmt,
            };
            _this.card.push(cardModel);
        });
    };
    AccountInfo.prototype.onChangeAccount = function (val) {
        this.activeFlagAccount = val.no;
        this.setCard(val.no);
        var cards = this.cardInfo.filter(function (e) { return e.account === val.no; });
        this.activeFlagNum = cards[0].cardNo;
        this.onChangeCard(cards[0]);
    };
    AccountInfo.prototype.onChangeCard = function (val) {
        this.activeFlagNum = val.cardNo;
        var cardSet = this.cardInfo.filter(function (e) { return e.cardNo === val.cardNo; });
        this.updateCardModel(cardSet[0]);
    };
    AccountInfo.prototype.getPhone = function () {
        var _this = this;
        this.personalService.findPersonalContact(this.currentCase.caseId).subscribe(function (data) {
            _this.phones = data.map(function (v) { return Object.assign({ recordsDataSet: [] }, v); });
        });
    };
    AccountInfo.prototype.sendSms = function () {
        var _this = this;
        if (this.currentRow == undefined || this.currentRow.id == undefined) {
            this.$message.warning("请选择短信模板");
            return;
        }
        fsRequest.post("/sms/send", {
            caseNumber: this.currentCase.caseNumber,
            templateParamNum: this.currentRow.paramNum,
            templateContent: this.currentRow.content,
            templateId: this.currentRow.id,
            // phones: ["17630042263"],
            phones: [this.phones[0].phoneNo],
            names: [this.currentCase.personalName],
            pName: this.pNameMapAsMap.get(this.currentCase.principalName),
        }).then(function (resp) {
            if (resp["code"] === 0) {
                _this.$message.success("发送成功");
                _this.smsDialogShow = false;
            }
            else {
                _this.$message.error("发送失败");
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    __decorate([
        collectionManageModule.State
    ], AccountInfo.prototype, "cardInfo", void 0);
    __decorate([
        collectionManageModule.State
    ], AccountInfo.prototype, "accountInfo", void 0);
    __decorate([
        collectionManageModule.State
    ], AccountInfo.prototype, "accountNumber", void 0);
    __decorate([
        collectionManageModule.State
    ], AccountInfo.prototype, "currentCase", void 0);
    __decorate([
        collectionManageModule.State
    ], AccountInfo.prototype, "currentCardNo", void 0);
    __decorate([
        collectionManageModule.Mutation
    ], AccountInfo.prototype, "updateCardModel", void 0);
    __decorate([
        Dependencies(SmsTemplateService)
    ], AccountInfo.prototype, "smsTemplateService", void 0);
    __decorate([
        Dependencies(PersonalService)
    ], AccountInfo.prototype, "personalService", void 0);
    __decorate([
        Watch("currentCase", {
            deep: true,
            immediate: false,
        })
    ], AccountInfo.prototype, "onCurrentCaseChange", null);
    __decorate([
        Watch("cardInfo", {
            immediate: true,
        })
    ], AccountInfo.prototype, "accountNumberChange", null);
    AccountInfo = __decorate([
        Component({
            components: {
                AddWarning: AddWarning,
                CommonTitle: CommonTitle,
                SvgIcon: SvgIcon,
            },
        })
    ], AccountInfo);
    return AccountInfo;
}(Vue));
export default AccountInfo;
